// Copyright (c) 2017 Deere & Company

export const dateComparator = (filterLocalDateAtMidnight, cellValue) => {

    const cellDate = cellValue;
    const filterDate = filterLocalDateAtMidnight.getTime();

    let returnValue;

    if (cellDate < filterDate) {

        returnValue = -1;

    } else if (cellDate > filterDate) {

        returnValue = 1;

    } else {

        returnValue = 0;

    }

    return returnValue;

};
